import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { LightboxImage } from './AttachmentLightbox';

type Props = {
  /** Свойства картинки из разметки содержимого */
  imageProps: Record<string, unknown>;
  /** Открыть картинку увеличенной */
  onOpen: (image: LightboxImage) => void;
  /** Картинка не загрузилась */
  onError: () => void;
};

/** Картинка оформленного содержимого: блоком во всю ширину облака, нажатием открывается увеличенной. */
export const ContentImage: FC<Props> = ({ imageProps, onOpen, onError }) => {
  const { t } = useTranslation(['dialogs']);
  const alt = typeof imageProps.alt === 'string' ? imageProps.alt : '';

  const handleClick = (event: MouseEvent<HTMLImageElement>) => {
    // Картинка внутри ссылки открывается увеличенной, а не переходом по ссылке
    event.preventDefault();
    const image = event.currentTarget;
    onOpen({ src: image.currentSrc || image.src, name: alt || t('dialogs:textFeed.attachment') });
  };

  return (
    <img
      {...imageProps}
      alt={alt}
      role="button"
      tabIndex={-1}
      aria-label={t('dialogs:textFeed.openImage')}
      className="my-2 block h-auto max-w-full cursor-zoom-in rounded-lg"
      onClick={handleClick}
      onError={onError}
    />
  );
};
